import { render, staticRenderFns } from "./newEmailTemplate.vue?vue&type=template&id=3c748b73&scoped=true"
import script from "./newEmailTemplate.vue?vue&type=script&lang=js"
export * from "./newEmailTemplate.vue?vue&type=script&lang=js"
import style0 from "./newEmailTemplate.vue?vue&type=style&index=0&id=3c748b73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c748b73",
  null
  
)

export default component.exports